import React, { useEffect, useState } from "react";
import secureStorage from "../../config/encrypt";
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import SkuList from "./SkuList";
import DealerService from "../../service/DealerService";
import SkuFilters from "./SkuFilters";

// eslint-disable-next-line no-unused-vars
const statusOptions = [
    { value: '1', label: 'Active' },
    { value: '2', label: 'Expired' },
];

const packEnabledOptions = [
    { value: '1', label: 'Enable' },
    { value: '0', label: 'Disable' },
];

const SkuPannel = () => {
    // eslint-disable-next-line no-unused-vars
    const { t } = useTranslation("dealer_sku_pannel");
    // eslint-disable-next-line no-unused-vars
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [skuRecords, setSkuRecords] = useState([]);
    const [skuTYpes, setSkuTypes] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [skuSubsciptionTypes, setSkuSubscriptionTypes] = useState([]);
    const [skuListingTypes, setSkuListingTypes] = useState([]);
    
    // Filter States
    const [filters, setFilters] = useState({
        search: '',
        skuName: null,
        skuType: null,
        listingType: null,
        status: null,
        is_enable: '',
    });

    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    // eslint-disable-next-line no-unused-vars
    const [pageSize] = useState(10); // number of records per page
    const [totalPages, setTotalPages] = useState(1);
    
    let loginResponse = secureStorage.getItem('loginUserInfo');
    let role_access = loginResponse && loginResponse.data && loginResponse.data.user_data && loginResponse.data.user_data.role_data && loginResponse.data.user_data.role_data.length > 0 ? loginResponse.data.user_data.role_data : []

    useEffect(() => {
        fetchSkuList();
        fetchSkuListinTypes();
        fetchSkuTypes();
    }, []);

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
    };

    const handleSearch = () => {
        fetchSkuList(1, filters); // page 1, with current filters
    };

    const handleReset = () => {
        const resetFilters = {
            search: '',
            skuName: null,
            skuType: null,
            listingType: null,
            status: null,
        };
        setFilters(resetFilters);
        fetchSkuList(1, resetFilters);
    };




    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            fetchSkuList(page, filters);
        }
    };

    const fetchSkuTypes = async () => {
        try {
            const response = await DealerService.getMasters(["dealer_sku"]);
            if (response.status === 200 && response.data.status === 200) {
                let responsedata = response.data.data || {};
                if (responsedata.dealer_sku && responsedata.dealer_sku.length) {
                    let subscM = [], skuM = [];
                    // eslint-disable-next-line array-callback-return
                    responsedata.dealer_sku.map(v => {
                        if (v.sku_type === "subscription") subscM.push(v);
                        if (v.sku_type === "service") {
                            skuM.push({
                                value: v.id,
                                label: v.sku_name,
                            });
                        };
                    });

                    setSkuTypes(skuM);
                    setSkuSubscriptionTypes(subscM);
                }
            }
        } catch (error) {

        } finally {

        }
    };

    const fetchSkuListinTypes = async () => {
        try {
            const listingTypeResponse = await DealerService.getSkuListingTypes();
            
            if (listingTypeResponse.status === 200 && listingTypeResponse.data.status === 200) {
                let responsedata = listingTypeResponse.data.data || [];

                const mappedListing = responsedata.map((lType) => ({
                    value: lType?.id,
                    label: lType?.attribute_value
                }));

                setSkuListingTypes(mappedListing);
            }
        } catch (error) {
            console.error('error==========>', error);
        }
    };

    const fetchSkuList = async (page = 1, filters = {}) => {
        setIsLoading(true);
        const paginationPayload = {
            page: page,
        };
        const payload = {
            ...paginationPayload,
            sku_name: filters.search || '',
            sku_type: filters.skuType?.value || '',
            listing_type: filters.listingType?.value || '',
            status: filters.status?.value || '',
            is_enable: filters.is_enable?.value || '',
        };

        const listResponse = await DealerService.getSkuPackageList(payload);
        if (listResponse && listResponse.status === 200 && listResponse?.data && listResponse?.data?.status === 200) {
            let records = listResponse?.data?.data?.data || [];
            let paginationDetails = listResponse?.data?.data?.pagination || {};
            setTotalPages(paginationDetails?.total_pages);
            setCurrentPage(paginationDetails?.current_page);
            setSkuRecords(records);
        }
        setIsLoading(false);
    };

    return (
        <div className={isLoading.loading ? "container-fluid loading" : "container-fluid"}>
            <div className="addStock">
                <div className="clearfix">
                    <div className="container-fluid new-theme">
                        <div className='m-md-l m-md-r'>
                            <h1>SKUs</h1>
                            <div className='dealer-card filter-form'>
                                <SkuFilters
                                    filters={filters}
                                    onFilterChange={handleFilterChange}
                                    onSearch={handleSearch}
                                    onReset={handleReset}
                                    skuTypes={skuTYpes}
                                    listingTypes={skuListingTypes}
                                    statusOptions={packEnabledOptions}
                                />
                            </div>
                        </div>
                    </div>
                    <SkuList
                        role_access={role_access}
                        sku_list={skuRecords}
                        sku_types={skuTYpes}
                        skuListingTypes={skuListingTypes}
                        isLoading={isLoading}
                        test={'testing'}
                        fetchSkuList={fetchSkuList}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        statusOptions={packEnabledOptions}
                    />
                </div>
            </div>
        </div>
    );
};

export default SkuPannel;